import {useState} from 'react';
import {ColumnDef} from '@tanstack/react-table';
import {Button} from '../shadcn-components/button';
import {Trash2, Pencil, ChevronUp, Minus} from 'lucide-react';
import {Checkbox} from '../shadcn-components/checkbox';
import {TableHeaderData} from '../../../app/data/types/tables/table-header';
import EditIcon from '../../../assets/img/icons/EditIcon';
import DeleteIcon from '../../../assets/img/icons/DeleteIcon';

export const columns = (data: TableHeaderData[]): ColumnDef<any>[] =>
	data.map(({
		key,
		name,
		isSelector,
		hasActions,
		isSortable
	}) => {
		const [isSwitchedArrow, setIsSwitchedArrow] = useState(false);

		if (isSelector) {
			return {
				id: 'select',
				header: ({table,}) => (
					<Checkbox
						onCheckedChange={(v) => table.toggleAllPageRowsSelected(!!v)}
						aria-label="Select all"
					/>
				),
				cell: ({row}) => (
					<Checkbox
						checked={row.getIsSelected()}
						onCheckedChange={(v) => row.toggleSelected(!!v)}
						aria-label="Select row"
					/>
				),
				enableSorting: false,
				enableHiding: false,
			} as ColumnDef<any>;
		}

		if (hasActions) {
			return {
				id: key,
				header: name,
				enableHiding: false,
				cell: ({row}) => {
					return (
						<div className={'flex items-center'}>
							<EditIcon className={'cursor-pointer p-2.5'} onClick={() => console.log(row.original.id, 'edit')}/>
							<DeleteIcon className={'cursor-pointer p-2.5k'} onClick={() => console.log(row.original.id, 'deleted')}/>
						</div>
					);
				},
			} as ColumnDef<any>;
		}
		if (isSortable) {
			return {
				id: key,
				accessorKey: key,
				header: ({column}) => (
					<span
						className={`flex items-center cursor-pointer transform transition-all duration-150 ease-in-out`}
						onClick={() => {
							column.toggleSorting(column.getIsSorted() === 'asc');
							setIsSwitchedArrow(!isSwitchedArrow);
						}}
					>
						{name}
						<span className={'relative '}>
							<ChevronUp className={`absolute top-[-8px] left-0 transition-all duration-150 ease-in-out ${isSwitchedArrow ?
																														'translate-y-2 rotate-180' :
																														''}`}/>
							<Minus className={`rotate-90 h-4`}/>
						</span>
					</span>
				),
				cell: ({row}) => {
					const v = row.getValue(key);
					if (typeof v === 'number') {
						return <div className="text-right font-medium">{v}</div>;
					}
					if (v instanceof Date) {
						return <div>{v.toLocaleDateString()}</div>;
					}
					return <div className="capitalize">{String(v)}</div>;
				},
				sortingFn: (rowA, rowB, columnId) => {
					const a = rowA.getValue(columnId);
					const b = rowB.getValue(columnId);
					if (a instanceof Date && b instanceof Date) {
						return a.getTime() - b.getTime();
					}
					if (typeof a === 'number' && typeof b === 'number') {
						return a - b;
					}
					return String(a).localeCompare(String(b), undefined, {sensitivity: 'base'});
				},
				enableSorting: true,
			} as ColumnDef<any>;
		}
		return {
			accessorKey: key,
			header: name,
			cell: ({row}) => (
				<div className="capitalize">{row.getValue(key)}</div>
			),
		} as ColumnDef<any>;
	});
